export const config = {
    urls: {
        'apiUrl': 'https://{hostname}:3467/api',
        'identityUrl': 'https://{hostname}:3467'
    }
};
